<template lang="pug">
.v-page-footer-contacts.page-footer__cell(v-if="footer" )
	.page-footer__block.flc(v-if="footer.contacts" )
		template(v-if="footer.contacts.link" )
			a(:href="footer.contacts.link?.href")
				v-svg-icon.page-footer__logo(:icon="footer.contacts.link?.icon")
		.page-footer__block-wrap
			h2.page-footer__block-title.flc(v-if="footer.contacts.title" ) {{footer.contacts.title}}
			.page-footer__block-subtitle.flc(v-if="footer.contacts.subtitle", v-html="footer.contacts.subtitle")

		template(v-if="footer.contacts.buttons")
			.contact-link-block.fllc(v-for="(button, index) in footer.contacts.buttons" :key="index")
				a.contact-link-button(:class="button.className" :href="button.href") {{ button.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			footer: {}
		};
	},

	methods: {
		dataSet(data) {
			this.footer = data;
		}
	}
};
</script>
